module.exports = __webpack_public_path__ + "assets/img/16-m.463b184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/16-m.jpg
// module id = zosO
// module chunks = 0